import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableStoreKeyComponent } from './table-store-key.component';
import {PortalModule} from "@angular/cdk/portal";
import {RouterModule} from "@angular/router";
import {IconsModule} from "../../components/icons/icons.module";
import {SmartTableModule} from "../../modules/smart-table/smart-table.module";
import {EntityLinkModule} from "../../components/entity-link/entity-link.module";
import {SharedModule} from "../../../modules/shared.module";
import {PaginationModule} from "../../components/pagination/pagination.module";
import {PreloaderModule} from "../../components/preloader/preloader.module";



@NgModule({
  declarations: [TableStoreKeyComponent],
  exports: [TableStoreKeyComponent],
  imports: [
    CommonModule,
    PortalModule,
    RouterModule,
    IconsModule,
    SmartTableModule,
    EntityLinkModule,
    SharedModule,
    PaginationModule,
    PreloaderModule
  ]
})
export class TableStoreKeyModule { }
